/**
 * @file MainMenu.tsx
 * @description Composant de navigation principal du cabinet
 */

import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ContainerOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  HomeOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { Button, Menu } from 'antd';
import type { MenuProps } from 'antd';
import './MainMenu.css';
import { useAuthStore } from '../../store/auth/useAuthStore';

const MainMenu: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const userCabinet = useAuthStore((state) => state.userCabinet);
  const cabinetName = userCabinet?.companyName || 'Nom cabinet';

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const items: MenuProps['items'] = [
    {
      key: 'cabinet',
      icon: <HomeOutlined />,
      label: cabinetName,
      onClick: () => navigate('/cabinet'),
    },
    {
      key: 'admin',
      icon: <DesktopOutlined />,
      label: 'Administration cabinet',
      onClick: () => navigate('/cabinet/parametre-cabinet'),
    },
    {
      key: 'licence',
      icon: <DatabaseOutlined />,
      label: 'Gestion des licences',
      onClick: () => navigate('/cabinet/licences'),
    },
    {
      key: 'lab',
      icon: <ContainerOutlined />,
      label: 'LAB',
      onClick: () => navigate('/cabinet/lab'),
    },
    {
      key: 'lettre',
      icon: <MailOutlined />,
      label: 'Lettre de missions',
      onClick: () => navigate('/cabinet/lettre-mission'),
    },
    {
      key: 'temps',
      icon: <DashboardOutlined />,
      label: 'Saisie des temps',
      onClick: () => navigate('/cabinet/saisie-temps'),
    },
    {
      key: 'facturation',
      icon: <CreditCardOutlined />,
      label: 'Facturation',
      onClick: () => navigate('/cabinet/facturation'),
    },
    {
      key: 'market',
      icon: <ShopOutlined />,
      label: 'Market place',
      onClick: () => navigate('/cabinet/marketplace'),
    },
  ];

  return (
    <div className="main-menu-container">
      {/* Toggle button */}
      <Button
        type="primary"
        onClick={toggleCollapsed}
        className={`menu-toggle-button ${collapsed ? 'collapsed' : 'expanded'}`}
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        aria-label="Toggle menu"
      />

      {/* Menu */}
      <Menu
        selectedKeys={['cabinet']}
        mode="inline"
        inlineCollapsed={collapsed}
        items={items}
        className="menu-content"
      />
    </div>
  );
};

export default MainMenu;
